import type { ReactNode } from 'react';

/**
 * Web: no native PDF engine — vault uses WebView / download flows in DocumentViewer.
 */
export type DocumentAttachmentPdfModalProps = {
  visible: boolean;
  uri: string;
  title?: string;
  onClose: () => void;
  onOpenElsewhere?: () => void;
  footerAccessory?: ReactNode;
  closeButtonMode?: 'icon' | 'done';
};

export function DocumentAttachmentPdfModal(_props: DocumentAttachmentPdfModalProps) {
  return null;
}
